import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenNib } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModule, Text,
} from '@domain-group/suit-theme'

import useStatus from '@hooks/useStatus'

import formatDate from '@functions/formatDate'
import { buildItemTitle } from '@functions/orderItem'

import StatusBadge from '@components/StatusBadge'

import type { OrderItemModel } from '@models/types'

interface OrderItemDetailsModuleProps {
  loading: boolean,
  orderItem: OrderItemModel | {},
}

const OrderItemDetailsModule = (props: OrderItemDetailsModuleProps) => {
  const { loading, orderItem } = props

  // @ts-expect-error TS2339
  const { color, status } = useStatus({ id: orderItem?.status_id })

  // @ts-expect-error TS2339
  const dueDate = orderItem?.dates?.due?.date
  const dueDateString = dueDate ? `Due on ${formatDate(dueDate, 'dd/MM/yyyy', 'DD')}` : ''

  return (
    <DashboardModule
      loading={loading}
      title="Order Item Details"
    >
      {!loading && (
        <Box justifyContent="flex-start" padding="large" alignItems="center">
          <Box
            alignItems="center"
            backgroundColor="#f8f8f8"
            borderRadius={5}
            flexShrink={0}
            height="36px"
            justifyContent="center"
            marginRight="medium"
            width="36px"
          >
            <FontAwesomeIcon icon={faPenNib} />
          </Box>

          <Box justifyContent="space-between" width="calc(100% - 42px)">
            <Box flexDirection="column" justifyContent="center" maxWidth="calc(100% - 122px)" marginRight="medium">
              <Text fontSize="small" color="bodyFontColor" marginBottom="small" variant="ellipsis">
                {buildItemTitle({ orderableItem: orderItem }!)}
              </Text>

              <Text color="bodyFontLightColor" fontSize="xsmall">
                {dueDateString}
              </Text>
            </Box>

            <Box
              flexDirection="column"
              alignItems="flex-end"
              justifyContent="center"
              maxWidth="30%"
            >
              {/*
               // @ts-expect-error TS2339 */}
              {orderItem?.id && (
                <Text fontSize="small" marginBottom="xsmall">
                  {/*
                   // @ts-expect-error TS2339 */}
                  #{orderItem?.id}
                </Text>
              )}

              {!!status && (
                <StatusBadge
                  boxProps={{ marginTop: 'small' }}
                  color={color}
                  ghost
                  // @ts-expect-error TS2339
                  statusId={status?.id}
                  // @ts-expect-error TS2339
                  text={status?.title}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}
    </DashboardModule>
  )
}

export default OrderItemDetailsModule
